import axios from "axios";
import { CONFIG, FORM_DATA_CONFIG } from "../utils/Common";

export const formDataPostCall = (url, data) => {
    return axios.post(url, data, { headers: FORM_DATA_CONFIG });
};
export const postCall = (url, data) => {
    return axios.post(url, data, { headers: CONFIG });
};
export const getCall = (url, data) => {
    return axios.get(url, { headers: CONFIG, params: data });
};

